import { useState } from 'react';
import { useShallow } from 'zustand/shallow';

import { ArticleTools } from 'app/modules/wallforming/components/scenes/toolbar/content/ArticleTools';
import { CameraSettings } from 'app/modules/wallforming/components/scenes/toolbar/content/CameraSettings';
import { InteractionModeToggle } from 'app/modules/wallforming/components/scenes/toolbar/content/InteractionModeToggle';
import { PoiFilterButton } from 'app/modules/wallforming/components/scenes/toolbar/content/PoiFilterButton';
import { ShortcutPanel } from 'app/modules/wallforming/components/scenes/toolbar/shortcuts/ShortcutPanel';
import { InteractionMode } from 'app/modules/wallforming/components/scenes/types/interactionMode';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Toolbar = () => {
    const [menuOpened, setMenuOpened] = useState<boolean>(false);
    const interactionMode = usePlacementStore(useShallow((state) => state.interactionMode));

    return (
        <>
            <div className="absolute top-10 left-4 z-10">
                <div className="flex flex-col items-start justify-start gap-y-2">
                    <ShortcutPanel />
                    <CameraSettings menuOpened={menuOpened} setMenuOpened={setMenuOpened} />
                    <InteractionModeToggle />

                    {/* POI navigation tools */}
                    <div
                        className="flex flex-col items-start justify-start gap-y-2"
                        style={{ display: interactionMode === InteractionMode.POI_NAVIGATION ? 'flex' : 'none' }}
                    >
                        <PoiFilterButton menuOpened={menuOpened} setMenuOpened={setMenuOpened} />
                    </div>

                    {/* Forming tools */}
                    <div
                        className="flex flex-col items-start justify-start gap-y-2"
                        style={{ display: interactionMode === InteractionMode.DEFAULT ? 'flex' : 'none' }}
                    >
                        <ArticleTools menuOpened={menuOpened} />
                    </div>
                </div>
            </div>
        </>
    );
};
